import { makeStyles } from '@material-ui/core';
import { ThemeInstance } from 'configs/theme';

export const useStyles = makeStyles((theme: ThemeInstance) => ({
  tooltip: {
    padding: '7px 10px',
    background: '#fff',
    border: '1px solid rgba(34, 64, 96, .2)',
  },
  icon: {
    marginRight: 10,
    fontSize: '1.4rem',
    color: 'rgb(255, 163, 0)',
  },
  title: {
    fontSize: 14,
    fontFamily: 'NeoSansStd',
    color: theme.custom.darkBlue,
  },
  flex: {
    display: 'flex',
    alignItems: 'center',
  },
  arrow: {
    color: 'rgba(34, 64, 96, .6)',
  },
}));
